// extracted by mini-css-extract-plugin
export default {"wrapper":"DfdBforsOB","actions":"ezOZcBG8cN"};